import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilLockLocked, cilUser } from "@coreui/icons";
import { useDispatch } from "react-redux";
import { loginUser, fetchUser } from "../redux/userSlice";
import "../styles/LoginPage.css"; // Import CSS for background styling
import logo from "../assets/images/Logo.png";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const password = event.target.password.value;
    if (!email || !password) {
      setErrorMessage("Email dan password harus diisi.");
      return;
    }
    setErrorMessage("");
    try {
      await dispatch(loginUser({ email, password })).unwrap();
      await dispatch(fetchUser()).unwrap();
      navigate("/raw-materials");
    } catch (error) {
      setErrorMessage(error.message || "Login failed. Please try again.");
    }
  };

  return (
    <div className="login-background min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleLogin}>
                    <h1 style={{ color: "#009844" }}>Sistem Informasi Produksi</h1>
                    <p className="text-body-secondary">
                      Masuk ke akun Anda
                    </p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        name="email"
                        placeholder="Email"
                        autoComplete="username"
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        name="password"
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                      />
                    </CInputGroup>
                    {errorMessage && (
                      <p style={{ color: "red" }}>{errorMessage}</p>
                    )}
                    <CRow>
                      <CCol xs={6}>
                        <CButton
                          type="submit"
                          style={{
                            backgroundColor: "#009844",
                            borderColor: "#009844",
                          }}
                          className="px-4 text-white"
                        >
                          Masuk
                        </CButton>
                      </CCol>
                      <CCol xs={6} className="text-right">
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard
                className="text-white py-5"
                style={{ width: "44%", backgroundColor: "#009844" }}
              >
                <CCardBody className="text-center">
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <img
                      src={logo}
                      alt="Logo"
                      style={{
                        width: "250px",
                        height: "250px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                        padding: "10px",
                      }}
                    />
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Login;
